
import { react, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import './DonationSignup.css';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CharitySignup from './CharitySignup';
import FundraiserSignup from './FundraiserSignup';
import { LoadScript } from '@react-google-maps/api';

import ReactGA from 'react-ga4';
ReactGA.initialize([{ trackingId: process.env.REACT_APP_GOOGLE_TAG }]);
const GOOGLE_MAPS_API_KEY = 'AIzaSyDqNnSuRDD3nyJ-oVOY4jV7McgqBIDyId0';

export default function DonationSignup() {
    const [selectedSignup, setSelectedSignup] = useState('');
    const [mapsLoaded, setMapsLoaded] = useState(false);


    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/DonationSignup' });
        }
    }, []);

    return (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        {/*  <HeaderSlogan />*/}
        <LoadScript
            googleMapsApiKey={GOOGLE_MAPS_API_KEY}
            libraries={['places']} // Make sure to include 'places' library
            onLoad={() => setMapsLoaded(true)}
        >
            {mapsLoaded == false ? null :

                selectedSignup == 'Charity' ?
                    <CharitySignup OnBack={() => setSelectedSignup('')} />
                    : selectedSignup == 'Fundraiser' ?
                        <FundraiserSignup OnBack={() => setSelectedSignup('')} />
                        :
                        <>
                            <div style={{ padding: '10px', backgroundColor: 'var(--sipzee-gray-3)', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <div style={{ marginTop: '15px', alignSelf: 'center' }}>
                                    <div style={{ color: 'white', fontSize: '16pt', fontWeight: 'bold' }}>
                                        Supercharge your fundraiser or supplement your charity
                                    </div>

                                    <div style={{ fontWeight: '600', lineHeight: '1.7rem', fontSize: '1rem', marginTop: '15px', display: 'flex' }}>
                                        <div style={{ borderRadius: '50%', border: '5px solid black', backgroundColor: 'var(--paper-root)', boxSizing: 'border-box', height: '100px', minWidth: '100px', width: '100px', display: 'flex', justifyContent: 'center' }}>
                                            <img src='/images/DonateIcon.png' style={{ height: '60px', width: '60px', alignSelf: 'center' }} />
                                        </div>
                                        <div style={{ alignSelf: 'center', marginLeft: '10px' }}>As a Charity, Sipzee offers your supporters another way to donate to you. Even accross the state!</div>
                                    </div>

                                    <div style={{ fontWeight: '600', lineHeight: '1.7rem', fontSize: '1rem', marginTop: '15px', display: 'flex' }}>

                                        <div style={{ alignSelf: 'center', marginRight: '10px' }}>As a Fundraiser, Sipzee lets you create temporary drives to support your cause.</div>
                                        <div style={{ borderRadius: '50%', border: '5px solid black', backgroundColor: 'var(--paper-root)', boxSizing: 'border-box', height: '100px', minWidth: '100px', width: '100px', display: 'flex', justifyContent: 'center' }}>
                                            <img src='/images/FundraiserIcon.png' style={{ height: '60px', width: '60px', alignSelf: 'center' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ borderTop: '10px solid var(--sipzee-green)', borderBottom: '10px solid var(--sipzee-green)', padding: '10px', display: 'flex', justifyContent: 'center' }}>
                                <table>
                                    <tr>
                                        <td><CreditCardOffIcon /></td>
                                        <td>Completely Free</td>
                                    </tr>
                                    <tr>
                                        <td><QrCodeIcon /></td>
                                        <td>Create customer QR codes for sharing/printing that links to your account.</td>
                                    </tr>
                                </table>


                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '25px' }}>
                                <div><Button variant='outlined' style={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => setSelectedSignup('Charity')}>Charity Signup</Button></div>
                                <div><Button variant='outlined' style={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => setSelectedSignup('Fundraiser')}>Fundraiser Signup</Button></div>
                            </div>
                        </>

                

            }
            </LoadScript>


    </div>)
}